module.exports = __webpack_public_path__ + "static/Icons_FirstTimeHB_Large-5e3bb5a71835fed266f9451a210e0f47.png";